import { SET_USERS_OF_COMPANY } from "../../actions/action-types";
import { updateCurrUser } from "../../actions/auth";
import { setUserFav, setUserView } from "../../actions/userPosition";
import { requestMethod } from "../../config/";
import config from "../../env.config";
import { checkApiSuccess } from "../../utils/common";
import { fetch } from "./api.service";

/**
 * saving te users of a company in redux store
 * @param {*} user
 * @returns {type Of Action}
 * @returns {list of users to set}
 */

export const saveUsersOfTheCompany = (users) => {
  return {
    type: SET_USERS_OF_COMPANY,
    payload: users,
  };
};

/**
 * getting all the users of a company
 * @param {*} companyId
 * @returns {type Of Action}
 * @returns {user to set}
 */

export const getUsersOfACompany = (companyId) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/user/getAllUserOfACompany`,
      params: {
        companyId: companyId,
      },
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      dispatch(saveUsersOfTheCompany(response.data.data));
    }
  };
};

export const getUserEmailControl = async (userId, isAdmin) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getUserEmailControl`,
    params: {
      selectedUserId: userId,
      isAdmin: isAdmin,
    },
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  }
};

/**
 * Update user email notification settings. Payload keys: isTaskUpdateEnabled, isApprovalEmailEnabled,
 * isTaskAssignEmailEnabled, isCommentEmailEnabled, isDailyDigestEnabled, approvalsPanel,
 * overdueAssignmentPanel, commentsPanel, remindersPanel, unseenEmailPanel, streamsPanel,
 * followedTaskPanel, emailTriggerDuration (number). Only send the key(s) that changed. 
 */
export const handleUserEmailControl = (payload, isAdmin) => {
  return async (dispatch) => {
    const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/user/changeUserEmailControl`,
      data: {
        ...payload,
        isAdmin: isAdmin,
      },

    };
    const response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      if (payload.isTaskUpdateEnabled !== undefined || payload.isDailyDigestEnabled !== undefined) {
        dispatch(
          updateCurrUser({
            notificationToggle: !!(payload.isTaskUpdateEnabled ?? payload.isDailyDigestEnabled),
          })
        );
      }
      return response?.data?.data;
    }
  };
};

export const configurePlanMyDay = async (payload) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/user/configurePlanMyDay`,
    data: payload,
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  }
};

export const getUserNotifEmailControl = async (userId) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getUserNotifEmailControl`,
    params: {
      userId,
    },
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  }
};

export const changeUserNotifEmailControl = async ({ userId, projectId, isPushNotifEnabled, isEmailEnabled }) => {
  let requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/user/changeUserNotifEmailControl`,
    data: {
      userId: userId,
      projectId: projectId,
      IsPushNotifEnabled: isPushNotifEnabled,
      IsEmailEnabled: isEmailEnabled,
    },
  };
  let response = await fetch(requestConfig, true, true);
  if (checkApiSuccess(response)) {
    return response?.data?.data;
  }
};

export const getUserView = (userId) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/user/getUserFavorites`,
      params: {
        userId,
      },
    };
    let response = await fetch(requestConfig, false, false);
    if (checkApiSuccess(response)) {
      await dispatch(setUserFav(response.data.data.userFav));
      await dispatch(setUserView(response.data.data.allViews));
    }
  };
};

export const getQueueInfo = (payload) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/queue/getQueueInfo`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const getProjectInfo = (payload) => {
  return async (dispatch, getState) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/project/getProjectInfo`,
      params: payload,
    };
    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      return response.data.data;
    }
  };
};

export const updateUserFavorite = (payload) => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/user/updateUserFavorite`,
      data: payload,
    };
    let response = await fetch(requestConfig, true, true);
    if (checkApiSuccess(response)) {
      return response?.data?.data;
    }
  };
};

export const getUserDetailsByUserId = async ({ uId, companyId }) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getUserDetailsByUserId`,
    params: {
      uId,
      companyId,
    },
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response?.data;
  }
};

/**
 * Search email contacts by search text
 * @param {string} searchText - The text to search for email contacts
 * @returns {Array} Array of email contact objects
 * @author Sejal
 */
export const searchEmailContacts = async (searchText) => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/searchEmailContactdetails`,
    params: {
      searchText,
    },
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return response?.data?.data || [];
  }
  return [];
};

/**
 * Check if company manager type exists.
 * Expects `response.data.data` like `{ managerTypeExists: 1 }` (truthy when 1 / true / "1").
 * @returns {boolean} True if manager type exists, false otherwise
 * @author Sejal
 */
export const checkIfCompanyManagerTypeExists = async () => {
  let requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/company/checkIfCompanyManagerTypeExists`,
  };
  let response = await fetch(requestConfig, true, false);
  if (checkApiSuccess(response)) {
    return Boolean(response.data.data.managerTypeExists);
  }
  return false;
};

